export { default } from "./LanguageSetting";
